import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import styled from 'styled-components'
import { useCallback, useEffect, useState, createRef } from 'react'
import GridItem from 'components/GridItem'
import Story from 'components/Story'
import { GlobalVariables } from 'Globals/GlobalVariables'
import { useEffectOnce } from 'usehooks-ts'
import { IoMdClose } from 'react-icons/io'

const articleId = '164225491366'

const MainComponent = ({
  tenant,
  colorMode,
  properties,
  trackEvent,
}: MicroFrontendProps) => {
  const [data, setData] = useState<any[]>([])
  const [archivedStories, setArchivedStories] = useState<any[]>([])
  const [isStoryOpen, setIsStoryOpen] = useState(false)
  const [animationPlayed, setAnimationPlayed] = useState(false)
  const [activeStory, setActiveStory] = useState(-1)
  const [isMobile, setIsMobile] = useState(false)

  const closeActiveStory = () => {
    setIsStoryOpen(false)
    setActiveStory(-1)
    setAnimationPlayed(false)
    document.body.style.overflow = 'auto'
    document.body.style.height = 'unset'
  }

  const handleResize = (): void => {
    setIsMobile(window.innerWidth < 600)
  }

  //import json file
  useEffectOnce(() => {
    fetch(
      'https://storage.googleapis.com/ta-interaktiv/trennungsgeschichten/geschichten.json'
    )
      .then((response) => response.json())
      .then((rawData: any) => {
        setData(rawData.data)
        setArchivedStories(
          rawData.data.filter(
            (stories: any) =>
              stories.publiziert === 'TRUE' && stories.featured !== 'TRUE'
          )
        )
      })

    // set height when window is resized
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  })
  //console.log('data', data)

  return (
    <AppContainer $colorMode={colorMode}>
      <div id='stories'>
        {data &&
          data
            .filter((stories) => stories.featured === 'TRUE')
            .map(function (item: any, itemIndex: number) {
              const id = item.Titel.replace(/\s/g, '').toLowerCase()
              return (
                <Story
                  isFeatured={true}
                  title={item.Titel}
                  short={item.Lead}
                  person={item.Person}
                  image={item.Bild}
                  caption={item.Legende}
                  text={item.Text}
                  id={id}
                  index={itemIndex}
                  key={itemIndex}
                  colorMode={colorMode}
                  articleId={articleId}
                ></Story>
              )
            }, [])}
        <Wrapper>
          {/* <h2>Weitere Leserinnen und Leser erzählen</h2> */}
          <Grid>
            {
              //map through data and create a GridItem for each item
              archivedStories &&
                archivedStories
                  .filter((stories) => stories.featured !== 'TRUE')
                  .map(function (item: any, itemIndex: number) {
                    const id = item.Titel.replace(/\s/g, '').toLowerCase()
                    return (
                      <GridItem
                        title={item.Titel}
                        short={item.Lead}
                        person={item.Person}
                        image={item.Bild}
                        caption={item.Legende}
                        text={item.Text}
                        id={id}
                        index={itemIndex}
                        key={itemIndex}
                        colorMode={colorMode}
                        setIsStoryOpen={setIsStoryOpen}
                        setActiveStory={setActiveStory}
                        setAnimationPlayed={setAnimationPlayed}
                        articleId={articleId}
                      ></GridItem>
                    )
                  }, [])
            }
          </Grid>
        </Wrapper>

        <Drawer
          style={{
            height: isStoryOpen ? (isMobile ? '90%' : '80%') : 0,
            opacity: isStoryOpen ? 1 : 0,
          }}
        >
          {isStoryOpen && (
            <Closer
              onClick={() => closeActiveStory()}
              style={{
                opacity: animationPlayed ? 1 : 0,
              }}
            >
              <div
                className='wrap'
                style={{
                  width: isMobile ? '94%' : '790px',
                  top: isMobile ? '12%' : '16%',
                  right: isMobile ? '0.5rem' : 'unset',
                }}
              >
                <IoMdClose />
              </div>
            </Closer>
          )}
          <div className='story-container'>
            {data && activeStory >= 0 && (
              <Story
                isFeatured={false}
                title={archivedStories[activeStory].Titel}
                short={archivedStories[activeStory].Lead}
                person={archivedStories[activeStory].Person}
                image={archivedStories[activeStory].Bild}
                caption={archivedStories[activeStory].Legende}
                text={archivedStories[activeStory].Text}
                id={archivedStories[activeStory].Titel.replace(
                  /\s/g,
                  ''
                ).toLowerCase()}
                index={activeStory}
                key={activeStory}
                colorMode={colorMode}
                articleId={articleId}
              ></Story>
            )}
          </div>
        </Drawer>

        {isStoryOpen && (
          <Dimmer
            style={{ display: isStoryOpen ? 'block' : 'none' }}
            onClick={() => closeActiveStory()}
          />
        )}
      </div>
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`${GlobalVariables}
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
`

const Drawer = styled.div`
  z-index: 5;
  position: relative;
  max-width: 800px;
  margin: 0 auto;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 5rem 3rem 2rem;
  @media only screen and (max-width: 600px) {
    padding: 0;
  }
  border-radius: 1rem 1rem 0 0;
  overflow-y: scroll;
  background-color: var(--site-background);
  -webkit-box-shadow: 0px 2px 25px 0px var(--beige-main);
  box-shadow: 0px 2px 25px 0px var(--beige-main);
  transition: height 0.3s ease-in;
`

const Dimmer = styled.div`
  z-index: 4;
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.15);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  transition: opacity 0.2s ease-in;
`

const Closer = styled.div`
  position: relative;
  font-size: 3rem;
  cursor: pointer;
  .wrap {
    position: fixed;
    text-align: right;
    svg {
      position: relative;
      right: 15px;
      background-color: var(--site-background);
      border-radius: 50%;
      padding: 0.5rem;
    }
  }
  transition: opacity 0.2s ease-in;
`

const Wrapper = styled.div`
  max-width: 1111px;
  margin: 0 auto;
  @media only screen and (max-width: 1111px) {
    padding: 0 1.5rem;
  }
  h2 {
    font-family: var(--font-serif);
  }
`

const Grid = styled.div`
  padding: 2rem 0;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 3.4rem;
  @media only screen and (min-width: 600px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media only screen and (min-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }
`

export default MainComponent
